import axios from 'axios';
import * as types from './AdminSizeCharts.types';
import * as selectors from './AdminSizeCharts.selectors';
import { adminValidateAuthInResponse, showNotification, empty } from './../../utils';
import * as dialog from './../common/dialog';

const apiUrl = process.env.REACT_APP_API_URL;

export const fetchElements = () => (dispatch, getState) => {
    const pagination = selectors.getPagination(getState());
    const sort = selectors.getSort(getState());
    const search = selectors.getSearch(getState());
    const searchType = selectors.getSearchType(getState());

    let params = [];
    params.push('active-page=' + pagination.activePage);
    params.push('elements-per-page=' + pagination.elementsPerPage);
    params.push('sort-column=' + sort.column);
    params.push('sort-type=' + sort.type);
    params.push('search=' + search);
    params.push('search-type=' + searchType);

    dispatch({ type: types.FETCH_ELEMENTS, payload: null });
    axios.get(apiUrl + '/uthealth-size-chart/admin-index?' + params.join('&'),
        { headers: { 'Authorization': `Bearer ${localStorage.getItem('access_token')}` } })
        .then((response) => {
            dispatch({ type: types.FETCH_ELEMENTS_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            dispatch(adminValidateAuthInResponse(error, types.FETCH_ELEMENTS_ERROR));
        });
}

export const fetchElement = (id) => (dispatch, getState) => {
    dispatch({ type: types.FETCH_ELEMENT, payload: null });
    axios.get(apiUrl + '/uthealth-size-chart/admin-view?id=' + id,
        { headers: { 'Authorization': `Bearer ${localStorage.getItem('access_token')}` } })
        .then((response) => {
            dispatch({ type: types.FETCH_ELEMENT_SUCCESS, payload: response.data });
            const table = JSON.parse(response.data.table_json);
            dispatch(setTable(table));
        })
        .catch((error) => {
            dispatch(adminValidateAuthInResponse(error, types.FETCH_ELEMENT_ERROR));
        });
}

export const saveElement = () => (dispatch, getState) => {
    const item = selectors.getItem(getState());
    const table = selectors.getTable(getState());
    const totalRows = selectors.getTotalRows(getState());
    const totalColumns = selectors.getTotalColumns(getState());
    const history = selectors.getHistory(getState());

    if (!validateSaveFields(item, totalRows, totalColumns)) {
        return;
    }

    let method = 'post';
    let endpoint = apiUrl + '/uthealth-size-charts';
    if (item.id && item.id != null) {
        method = 'put';
        endpoint = apiUrl + '/uthealth-size-charts/' + item.id;
    }

    dispatch({ type: types.SAVE_ELEMENT, payload: null });
    axios({
        method: method,
        url: endpoint,
        data: {
            name: item.name,
            active: item.active,
            table,
            line1: item.line1,
            line2: item.line2,
            line3: item.line3,
            line4: item.line4,
            line5: item.line5,
            line6: item.line6,
        },
        headers: { 'Authorization': `Bearer ${localStorage.getItem('access_token')}` },
    }).then((response) => {
        dispatch({ type: types.SAVE_ELEMENT_SUCCESS, payload: response.data });
        showNotification('Item Saved', 'The item has been saved successfully', 'success');
        history.push('/admin/size-charts')
    }).catch((error) => {
        dispatch(adminValidateAuthInResponse(error, types.SAVE_ELEMENT_ERROR));
    });
}

export const deleteItem = () => (dispatch, getState) => {
    const idModal = selectors.getIdModal(getState());

    dispatch({ type: types.DELETE_ITEM, payload: null });
    axios.delete(apiUrl + '/uthealth-size-charts/' + idModal,
        { headers: { 'Authorization': `Bearer ${localStorage.getItem('access_token')}` } })
        .then((response) => {
            dispatch({ type: types.DELETE_ITEM_SUCCESS, payload: response.data });
            dispatch(dialog.actions.hideDialog('delete-modal'));
            showNotification('Item Deleted', 'The item has been deleted successfully', 'success');
            dispatch(fetchElements());
        })
        .catch((error) => {
            dispatch(adminValidateAuthInResponse(error, types.DELETE_ITEM_ERROR));
        });
}

export const duplicateElement = (id) => (dispatch, getState) => {
    dispatch({ type: types.DUPLICATE_ITEM, payload: null });
    axios.post(apiUrl + '/uthealth-size-chart/duplicate', { id },
        { headers: { 'Authorization': `Bearer ${localStorage.getItem('access_token')}` } })
        .then((response) => {
            dispatch({ type: types.DUPLICATE_ITEM_SUCCESS, payload: response.data });
            showNotification('Item Duplicated', 'The item has been duplicated successfully', 'success');
            dispatch(fetchElements());
        })
        .catch((error) => {
            dispatch(adminValidateAuthInResponse(error, types.DUPLICATE_ITEM_ERROR));
        });
}

export const validateSaveFields = (fields, totalRows, totalColumns) => {
    if (empty(fields.name)) {
        showNotification('Complete Information', 'Enter the Name', 'info');
        return false;
    }
    if (parseInt(totalRows) === 0 || parseInt(totalColumns) === 0) {
        showNotification('Complete Information', 'Add at least one column and row to the Chart', 'info');
        return false;
    }

    return true;
}

export const setActionType = (value) => (dispatch) => {
    dispatch({
        type: types.SET_ACTION_TYPE,
        payload: value
    });
}

export const setActivePage = (value) => (dispatch, getState) => {
    new Promise(resolve => {
        dispatch({
            type: types.SET_ACTIVE_PAGE,
            payload: value,
        });
        resolve();
    }).then(() => {
        dispatch(fetchElements());
    });
}

export const setSort = (column, type) => (dispatch) => {
    new Promise(resolve => {
        dispatch({
            type: types.SET_SORT,
            payload: { column, type }
        });
        resolve();
    }).then(() => {
        dispatch(fetchElements());
    });
}

export const setSearch = (value) => (dispatch) => {
    dispatch({
        type: types.SET_SEARCH,
        payload: value,
    });
}

export const setSearchType = (value) => (dispatch) => {
    dispatch({
        type: types.SET_SEARCH_TYPE,
        payload: value,
    });
}

export const setField = (field, value) => (dispatch) => {
    dispatch({
        type: types.SET_FIELD,
        payload: { field, value },
    });
}

export const setHistory = (value) => (dispatch) => {
    dispatch({
        type: types.SET_HISTORY,
        payload: value,
    });
}

export const setIdModal = (id) => (dispatch) => {
    dispatch({
        type: types.SET_ID_MODAL,
        payload: id
    });
}

export const setTable = (table) => (dispatch) => {
    let rows = table.length;
    let cols = 0;
    if (table.length > 0) {
        cols = table[0].length
    }

    dispatch({
        type: types.SET_TABLE,
        payload: { table, rows, cols },
    })
}

export const setTableCell = (row, col, value) => (dispatch) => {
    dispatch({
        type: types.SET_TABLE_CELL,
        payload: { row, col, value },
    })
}

export const resetState = () => (dispatch) => {
    dispatch({
        type: types.RESET_STATE,
        payload: null,
    })
}